// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaQvpkHtYLXm8A {
  position: relative;
}
.soXZlNtcEffBQC {
  justify-content: space-around;
  min-width: 115px;
}
.soXZlNtcEffBQC:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
}
.mac .soXZlNtcEffBQC:focus {
  outline-color: -webkit-focus-ring-color;
}
.soXZlNtcEffBQC:focus .mac.firefox {
  outline-color: AccentColor;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CaQvpkHtYLXm8A`,
	"button": `soXZlNtcEffBQC`
};
export default ___CSS_LOADER_EXPORT___;
